import type { TranslationKey } from "../locales";
import { LocalizedError, type LocalizedErrorOptions } from "./localized-error";

/**
 * The request is well formed and it is the state that refuses it: the order has moved on since
 * the screen last read it, the calculation is locked, the warehouse has no receiving zone yet.
 * Configuration the organisation has not made counts the same way — fixed once, the request
 * then works. 409, code `conflict`.
 */
export class ConflictError extends LocalizedError {
	readonly status = 409 as const;
	readonly code: string;

	constructor(key: TranslationKey, options?: LocalizedErrorOptions) {
		super(key, options);
		this.name = "ConflictError";
		this.code = options?.code ?? "conflict";
	}
}
